<template>
  <TableLayout :permissions="['business:companyUser:query']">
    <!-- 搜索表单 -->
    <el-form ref="searchForm" slot="search-form" :model="searchForm" label-width="100px" inline>
      <el-form-item label="企业名称" prop="companyName">
        <el-input v-model="searchForm.companyName" placeholder="请输入企业名称" @keypress.enter.native="search"></el-input>
      </el-form-item>
      <!-- <el-form-item label="企业简称" prop="shortName">
        <el-input v-model="searchForm.shortName" placeholder="请输入企业简称" @keypress.enter.native="search"></el-input>
      </el-form-item> -->
      <el-form-item label="账号信息" prop="keyWords">
        <el-input v-model="searchForm.keyWords" placeholder="请输入登录账号/姓名" @keypress.enter.native="search"></el-input>
      </el-form-item>
      <el-form-item label="状态" prop="status">
        <el-select v-model="searchForm.status" clearable placeholder="请选择" @change="search">
          <el-option label="启用" :value="0"></el-option>
          <el-option label="禁用" :value="1"></el-option>
        </el-select>
      </el-form-item>
      <section>
        <el-button type="primary" @click="search">搜索</el-button>
        <el-button @click="reset">重置</el-button>
      </section>
    </el-form>
    <!-- 表格和分页 -->
    <template v-slot:table-wrap>
      <el-table v-loading="isWorking.search" :data="tableData.list" border stripe
        @selection-change="handleSelectionChange">
        <!-- <el-table-column type="selection" width="55" align="center"></el-table-column> -->
        <el-table-column prop="companyName" label="企业名称" min-width="100px" align="center"></el-table-column>
        <el-table-column prop="username" label="登录账号" min-width="100px" align="center"></el-table-column>
        <el-table-column prop="realname" label="姓名" min-width="100px" align="center"></el-table-column>
        <el-table-column prop="mobile" label="手机号" min-width="100px" align="center"></el-table-column>
        <el-table-column prop="status" label="状态" min-width="100px" align="center">
          <template slot-scope="{row}">
            <!-- 0启用 1禁用 -->
            <el-switch :disabled="!containPermissions(['business:companyUser:update'])" v-model="row.status"
              :inactive-value="1" :active-value="0" @change="changeStatus(row)">
            </el-switch>
          </template>

        </el-table-column>
        <el-table-column prop="createTime" label="创建时间" min-width="140px" align="center"></el-table-column>
      </el-table>
      <pagination @size-change="handleSizeChange" @current-change="handlePageChange" :pagination="tableData.pagination">
      </pagination>
    </template>

  </TableLayout>
</template>

<script>
import BaseTable from '@/components/base/BaseTable'
import TableLayout from '@/layouts/TableLayout'
import Pagination from '@/components/common/Pagination'
import { updateById } from '@/api/system/user'
export default {
  name: 'Company',
  extends: BaseTable,
  components: { TableLayout, Pagination },
  data() {
    return {
      oepnValidDate: [],
      // 搜索
      searchForm: {
        companyName: '',
        keyWords: '',
        status: '',
        type: 2
      }
    }
  },
  created() {
    this.config({
      module: '系统-企业信息表',
      api: '/business/companyUser',
      'field.id': 'id',
      'field.main': 'id'
    })
    this.search()
  },
  methods: {
    selectOepnValidDate(v) {
      [this.searchForm.oepnValidDateStart, this.searchForm.oepnValidDateEnd] = v
    },
    reset() {
      // this.reset()
      this.$refs.searchForm.resetFields()
      this.searchForm.oepnValidDateStart = ''
      this.searchForm.oepnValidDateEnd = ''
      this.oepnValidDate = []
      this.search()
    },
    changeStatus(row) {
      updateById(row)
        .then(() => {
          this.$tip.apiSuccess('更新成功')
        })
        .catch(err => {
          this.$tip.apiFailed(err)
        })
        .finally(() => {
          this.handlePageChange()
        })
    }
  },
}
</script>
